import { ArrowRight, LockKeyhole, ShieldCheck } from "lucide-react";
import { useState } from "react";

import { ApiError, apiRequest } from "../lib/apiClient";
import { Brand } from "./Brand";

type LoginKind = "admin" | "customer";

export function LoginPanel({
  kind,
  onAuthenticated,
}: {
  kind: LoginKind;
  onAuthenticated: () => void;
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setPending(true);
    setError("");
    try {
      await apiRequest(`/api/v1/${kind}/auth/login`, {
        method: "POST",
        body: {
          email,
          password,
          ...(kind === "admin" && totpCode ? { totpCode } : {}),
        },
      });
      onAuthenticated();
    } catch (caught) {
      setError(
        caught instanceof ApiError
          ? caught.message
          : "La connexion n'a pas pu etre etablie.",
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="auth-page">
      <header className="auth-header">
        <Brand context={kind === "admin" ? "Administration" : "Studio"} />
        <a href="/">Retour au vocal</a>
      </header>
      <main className="auth-main">
        <section className="auth-panel" aria-labelledby="auth-title">
          <div className="auth-icon">
            {kind === "admin" ? <ShieldCheck /> : <LockKeyhole />}
          </div>
          <p className="eyebrow">
            {kind === "admin" ? "Acces interne" : "Espace client"}
          </p>
          <h1 id="auth-title">
            {kind === "admin" ? "Console Vox" : "Votre espace Vox"}
          </h1>
          <p className="muted">
            Utilisez le compte qui vous a ete attribue. Les connexions et les
            actions sensibles sont journalisees.
          </p>

          <form onSubmit={submit}>
            <label>
              Adresse e-mail
              <input
                autoComplete="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </label>
            <label>
              Mot de passe
              <input
                autoComplete="current-password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>
            {kind === "admin" ? (
              <label>
                Code TOTP
                <input
                  autoComplete="one-time-code"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="Si active"
                  value={totpCode}
                  onChange={(event) =>
                    setTotpCode(event.target.value.replace(/\D/g, ""))
                  }
                />
              </label>
            ) : null}
            {error ? <p className="form-error">{error}</p> : null}
            <button className="primary-button" disabled={pending} type="submit">
              {pending ? "Connexion..." : "Se connecter"}
              <ArrowRight size={17} />
            </button>
          </form>
        </section>
      </main>
      <footer className="public-footer">
        Service tiers independant, non affilie a Roblox Corporation.
      </footer>
    </div>
  );
}
